import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import './InvoicePrintPages.css';

interface IHandlingLabelSheet {
  SendersName: string | null;
  AddressLine1: string | null;
  AddressLine2: string | null;
  AddressLine3: string | null;
  AddressLine4: string | null;
  Number: number;
  Quantity: number;
  OrderedItemId: number;
  PublicId: string;
  OrderId: number;
}

interface IHandlingLabelsData {
  Pending: boolean;
  Labels: IHandlingLabelSheet[];
}

const PrintHandlingLabelsPage = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [data, setData] = useState<IHandlingLabelsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!invoiceId) return;
    setLoading(true);
    store.server
      .getApi2<IHandlingLabelsData>(`../Purchase/GetHandlingLabelsData/${invoiceId}`)
      .then((res: ServerResponse<IHandlingLabelsData>) => {
        if (res.Success) {
          setData(res.Value);
        } else {
          toast.error(res.Message || 'Unable to load handling labels.', { autoClose: false });
        }
      })
      .finally(() => setLoading(false));
  }, [invoiceId]);

  if (loading) {
    return (
      <div className="invoice-print-page" data-testid="handling-labels-page">
        <p>Loading handling labels…</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="invoice-print-page" data-testid="handling-labels-page">
        <div className="alert alert-danger">Unable to load handling labels.</div>
      </div>
    );
  }

  return (
    <div className="invoice-print-page" data-testid="handling-labels-page">
      <div className="panel panel-default">
        <div className="panel-heading no-print">
          <i className="fa fa-file-text-o" />&nbsp;Handling Labels
        </div>
        <div className="panel-body">
          <div className="alert alert-info no-print">
            <h3>
              <i className="fa fa-print" />&nbsp;Print Handling Labels
            </h3>
            Each package must have its own handling label. Do not create copies; if you need additional handling labels
            they must be purchased.
            <div className="bumper-t">
              <button type="button" className="btn btn-default" onClick={() => window.print()}>
                <i className="fa fa-print" />&nbsp;Print
              </button>
            </div>
          </div>

          {(data.Labels || []).length === 0 && (
            <div className="alert alert-warning">No handling labels found on this invoice.</div>
          )}

          {(data.Labels || []).map((label, idx) => (
            <div key={`${label.OrderedItemId}-${label.Number}-${idx}`} className="handling-label-sheet">
              <div className="handling-label-sender">
                {label.SendersName}
                <br />
                {label.AddressLine1}
                <br />
                {label.AddressLine2}
                <br />
                {label.AddressLine3}
                <br />
                {label.AddressLine4}
                <br />
                <br />
                <br />
              </div>
              <div className="handling-label-destination text-center">
                University of Maryland
                <br />
                Stamp Student Union
                <br />
                3972 Campus Drive
                <br />
                College Park, MD 20742
                <br />
                <br />
                <strong>HOLD FOR NATIONAL HISTORY DAY&nbsp;&nbsp;&nbsp;</strong>
                <br />
                <br />
              </div>
              <div className="handling-label-meta text-right">
                {label.Number} of {label.Quantity}
                <br />
                {label.OrderedItemId} | {label.PublicId} | {label.OrderId}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrintHandlingLabelsPage;
